import { render, staticRenderFns } from "./CollectionsDataSources.vue?vue&type=template&id=342cc792&scoped=true"
import script from "./CollectionsDataSources.vue?vue&type=script&lang=js"
export * from "./CollectionsDataSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342cc792",
  null
  
)

export default component.exports